import EventEmitter from"../vendor/emitter/EventEmitter";export default new EventEmitter;